import { render, staticRenderFns } from "./GenericAvatar.vue?vue&type=template&id=75f4f35a"
import script from "./GenericAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericAvatar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GenericAvatar.vue?vue&type=style&index=0&id=75f4f35a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports